import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * A card component displaying the user's energy usage
 * 
 * @param {Object} props - Component props
 * @param {number} props.usage - User's energy usage in kWh
 * @param {string} props.period - The period for which usage is shown (e.g., "Today", "This Month")
 * @param {boolean} props.showViewDataLink - Whether to show the "View Electricity Data" link
 */
const EnergyUsageCard = ({ usage, period = 'Today', showViewDataLink = true }) => {
  return (
    <div className="card bg-white shadow-md rounded-lg p-6">
      <h2 className="text-gray-500 text-sm font-semibold uppercase mb-2 font-mont">Energy Usage {period}</h2>
      <div className="flex items-baseline">
        <span className="text-3xl font-bold text-hooray-dark-text">
          {(typeof usage === 'number' ? usage.toFixed(2) : '0.00')} kWh
        </span>
      </div>
      {showViewDataLink && (
        <Link 
          to="/electricity-data" 
          className="mt-4 text-sm text-hooray-red hover:text-hooray-yellow inline-flex items-center"
        >
          View Electricity Data →
        </Link>
      )}
    </div>
  );
};

EnergyUsageCard.propTypes = {
  usage: PropTypes.number,
  period: PropTypes.string,
  showViewDataLink: PropTypes.bool
};

export default EnergyUsageCard; 